import axios from 'axios';
import { logger } from '../lib/logger';

// Production custom domains: always use same-origin so /api/* hits the backend
// pod via the ingress rule. This way the user does NOT need to set
// REACT_APP_BACKEND_URL in the deployment dashboard — it just works.
const PROD_HOSTS = new Set(['kriptodestek.com', 'www.kriptodestek.com']);

function resolveBackendUrl() {
    if (typeof window !== 'undefined' && window.location && PROD_HOSTS.has(window.location.hostname)) {
        return window.location.origin;
    }
    return process.env.REACT_APP_BACKEND_URL;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,  // send httpOnly auth cookie
});

// Auth lives only in the httpOnly cookie. Purge any token left by pre-cookie builds.
try {
    localStorage.removeItem('cds_token');
} catch (e) {
    logger.warn('legacy token purge failed', e);
}

apiClient.interceptors.response.use(
    (r) => r,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem('cds_user');
            // Don't redirect from /auth/me probe (silent re-hydrate) or auth pages
            const url = error?.config?.url || '';
            const path = window.location.pathname;
            if (!url.includes('/auth/me') && path !== '/login' && path !== '/signup') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);
